import { Component, OnInit, ViewChild } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { CurrentSelection, JobSite, SelectionLists, Make, Model } from '../../../app/entities';
import { AppService } from '../../../app/app.service';
import { equipmentListVM } from '../component-forecast/component-forecast.model';
import { ComponentForecastService } from '../component-forecast/component-forecast.service';
import { ManageComponentsService } from '../manage-components/manage-components.service';
import { SetupEquipmentService } from '../setup-equipment/setup-equipment.service';
import { JobsiteTypeVM, ComponentTypeVM,ComponentPerformanceVM, filterComponentPerformance, CmponentSearchResult, ComponentActionHistroyVM } from '../manage-components/manage-components.model';
import { SelectionModel } from '@angular/cdk/collections';
import { ComponentActionHistoryComponent } from './components/component-action-history/component-action-history.component';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

const Graphdata = {
  chart: {
    caption: "Component Replacement",
    xaxisname: "Component Replacement Date",
   
    yaxisname: "Life Achieved in Hours",
    subcaption: "[Time Period]",
    numbersuffix: "hrs",
    rotatelabels: "1",
    setadaptiveymin: "1",
    theme: "fusion"
  },categories: [
    {
      verticallinedashed: "1",
      verticallinedashlen: "1",
      verticallinedashgap: "1",
      verticallinethickness: "1",
      verticallinecolor: "#000000",
      category: [
        {
          x: "20",
          label: "20°F",
          showverticalline: "0"
        },
        {
          x: "40",
          label: "40°F"
        },
        {
          x: "60",
          label: "60°F"
        },
        {
          x: "80",
          label: "80°F"
        },
        {
          x: "100",
          label: "100°F"
        }
      ]
    }
  ],
  dataset: [
    {
      data:[
        {
      label: "0",
      value: "0"
    }
      ]
    }
  ],

  "trendlines": [{
    "line": [
      
      {
      "startvalue": "0",
        "color": "0",
        "thickness": "2",
        "alpha": "60",
    },
    {
      "startvalue": "0",
        "color": "0",
        "thickness": "4",
        "alpha": "60",
    }
  ]
}]

};
@Component({
  selector: 'app-component-life-performance',
  templateUrl: './component-life-performance.component.html',
  styleUrls: ['./component-life-performance.component.scss'],
  animations: [
    trigger(
        'enterAnimation', [
            transition(':enter', [
                style({ height: '1px', opacity: 0 }),
                animate('250ms', style({ height: '324px', opacity: 1 }))
            ]),
            transition(':leave', [
                style({ height: '324px', opacity: 1 }),
                animate('250ms', style({ height: '1px', opacity: 0 }))
            ])
        ]
    )],
})

export class ComponentLifePerformanceComponent implements OnInit {
  _dropDownLists: SelectionLists = new SelectionLists();
  _dropDownListsFiltered: SelectionLists = new SelectionLists();
  _currentSelection: CurrentSelection = new CurrentSelection();
  equipmnentList: equipmentListVM[]
  selectedMake: Make;
  selectedCustomerValue:number;
  CustomerList;
  selectedModel: Model;
  jobsite:JobSite;
  typeid:number
  selectedJobsite:number;
  jobSiteList;
  selectedJobsiteType:number[] = [];
  Model = true
  jobsitetypesList : JobsiteTypeVM[];
  componenttypesList : ComponentTypeVM[];  
  componentList:ComponentTypeVM[];
  filtercomponentList:ComponentTypeVM[];
  componentperformancelist:ComponentPerformanceVM[];
  selectedCompType:number[] = [];
  selectedComp:number[]=[];
  show:boolean=false
  selectedSide:number
  showTable:boolean=false;
  selectedMakeValue:number;
  dealerValue:number;
  selectModelValue:number;
  EquipmentId: number[] = [];
  startDate:string;
  enddate:string;
  isCurrentlyFitted:boolean;
  IscountCheckedValues:boolean;
  userName
  dealerList
  dealerID:number;
  SelectedBrand; number;
  performSearchedList:CmponentSearchResult;
  selectedEquipments:number;
  FilteredGraphData:ComponentPerformanceVM[]= [];
  width = 600;
  height = 400;
  type = "scatter";
  dataFormat = "json";
  dataSourceGraph = Graphdata;
  selectUpperValue;
  selectLowerValue;
  noRecords = false;
currentdate =  new Date().getFullYear().toString();
Customer = true
Jobsite = true
UnitNo = true
Family = true
Make = true

  showPerformanceTable()
  {
    
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    // console.log('make',this.selectedMake) 
    // console.log('customer', this.selectedCustomer)
    // console.log('jobsite',this.selectedJobsite) 
    // console.log('serial no',this.EquipmentId) 
    // console.log('Unit no', this.selectedEquipments)
    // console.log('family',this.typeid)
    // console.log('model',this.selectModelValue)
    // console.log('next row')
    // console.log('Job site type', this.selectedJobsiteType)
    // console.log('Brand', this.selectedMakeValue)
    // console.log('Component Type', this.selectedCompType)
    // console.log('Component', this.selectedComp)
    // console.log('side', this.selectedSide)
    // console.log('Start Date', this.startDate)
    // console.log('End Date',this.enddate)
    // console.log('data', this.dataSource.data=[])
  }
  displayedColumns: string[] = ['customerName', 'jobSiteName', 'brandName', 'family','model', 'unitNo','ComponentType','componentName','part','side','hoursOnSurface','worn','evalCode','Cost','startDate', 'normalize100', 'normalize120','dateRemoved', 'costPerhour','select'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource = new MatTableDataSource();
  selection = new SelectionModel(true, []);
  //Averages table
  displayedaverageColumns: string[] = [ 'name', 'weight', 'symbol'];
  //dataAvveragesSource = new MatTableDataSource();;
 // inventorySearchFilter: InventorySearchItems = new InventorySearchItems(2000);
  constructor( private _appService: AppService,
    public _fleetService: ComponentForecastService,
    public _componentService: ManageComponentsService,
    private _equipmentService: SetupEquipmentService,
    private _dialog: MatDialog,
    // private _equipmentService: ManageEquipmentService,   
    ) { 
    }

  ngOnInit() {
    this._appService.setPageTitle('Component Life Performance');
    //const customers = this._appService.getCustomerListForSelection(1, 10000);
    //const jobsites = this._appService.getJobSiteListForSelection(1, 10000);
    this._appService.getCustomerListForSelection(1, 10000).subscribe(result => {
      this.CustomerList = result;
      this._dropDownListsFiltered.customerList = result;
    })
     this._appService.getJobSiteListForSelection(1, 10000).subscribe(result => {
       this.jobSiteList = result
     })
    //const equipments = this._appService.getEquipmentListForSelection(1, 10000);
    this._fleetService.getFamilyList();
    
    this._componentService.getModelList();
    this.GetJobsiteTypesList();
    this.GetComponentTypesList();
   this.GetComponentList();
   //this.GetComponentPerformanceList();
  


  // const modelList = this._equipmentService.getModelList(equipment.MakeId);

    // Observable.forkJoin([customers, jobsites, equipments]).subscribe(results => {
    //   this._dropDownLists.customerList = results[0];
    //   this._dropDownListsFiltered.customerList = results[0];
    //   this._dropDownLists.jobSiteList = results[1];
    //   this._dropDownLists.equipmentList = results[2];
    //   //this._loading.finishedLoading();
    //   //this.isloading = false;
    // });
    //  Observable.forkJoin([customers, jobsites]).subscribe(results => {
    //    this._dropDownLists.customerList = results[0];
    //    this._dropDownListsFiltered.customerList = results[0];
    //    this._dropDownLists.jobSiteList = results[1];
    //  });
    this._appService.getMakeListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.makeList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        //this._loading--;
      }
    );


    this._fleetService.getDealerList(this.userName).subscribe(result => {
      this.dealerList = result
     
    });


    

    // this._appService.getMakeListForSelection(1, 10000).subscribe(
    //   result => {
    //     this._dropDownLists.makeList = result;
    //   },
    //   error => {
    //     console.error(error);
    //   },
    //   () => {
    //    // this._loading--;
    //   }
    // );

    // this._appService.getModelListForSelection(1, 10000).subscribe(
    //   result => {
    //     this._dropDownLists.modelList = result;
    //   },
    //   error => {
    //     console.error(error);
    //   },
    //   () => {
    //     //this._loading--;
    //   }
    // );
  }

  

  customerChanged(event) {
    this.selectedCustomerValue = event.value;
    if (!this.selectedCustomerValue) return;
    this._dropDownListsFiltered.jobSiteList = this.jobSiteList.filter(m => m.CustomerId === this.selectedCustomerValue);
    this._currentSelection.jobSite = new JobSite();
    this._dropDownListsFiltered.equipmentList = [];
  }

 

  makeChanged(event) {
    this.selectedMake = event.value;
    if (!this.selectedMake) {
      return;
    }
    //this.inventorySearchFilter.MakeId = this.selectedMake.Id;
   // console.log(this._dropDownLists.modelList);
    //console.log(this.selectedMake);
    // this._dropDownListsFiltered.modelList = this._dropDownLists.modelList.filter(
    //   m => m.MakeId === this.selectedMake.Id
    // );
    //this.search();



    //new code
    this._equipmentService.GetModelListByfamilyandMakeLifePerformance(this.selectedMakeValue,this.typeid !=null?this.typeid:0).subscribe(r => {
      //this.modelList = r;     
      this._componentService.availableModelList = r;
      //this._loading.finishedLoading();
      //console.log(r)
    });
  }




//Get Jobsite Types
GetJobsiteTypesList(){
  this._equipmentService.GetJobsiteTypes().subscribe(res=>{
    //console.log("jobsitetypes", res)
    this.jobsitetypesList = res;
  })
}

GetComponentTypesList(){
  this._equipmentService.GetComponentTypes().subscribe(res=>{
    //console.log("component types", res)
    this.componenttypesList = res;
  })
}

// GetComponentPerformanceList()
// {

  
//   this._equipmentService.GetComponentPerformance(this.EquipmentId).subscribe(res=>
//   {
//     console.log('component performance', res)
//     this.componentperformancelist=res;
//     this.dataSource.data = res;
//   })
// }

resetFields()
{
  this.selectedCustomerValue = 0;
  this.selectedMakeValue = 0;
  this.dealerValue=0;
 this.EquipmentId = [];
this.selectedJobsite=0;
this.typeid = 0;
this.selectedEquipments=0;
this.selectModelValue = 0
this.dataSource.data=[];
this.selectedJobsiteType= [];
this.selectedCompType=[];
this.selectedSide=0;
this.startDate="";
this.enddate="";
this.dealerID=0;

}


GetComponentList(){
  this._equipmentService.GetComponent().subscribe(res=>{
    //console.log("component", res)
    this.componentList = res;
    this.filtercomponentList =res;
  })
}
//newcode component type
changeCompType(){
  this.componentList = this.filtercomponentList;
  if(this.selectedCompType.length>0){
    this.componentList = this.componentList.filter(x=>x.comTypeAuto==this.selectedCompType);

  }
}
// end code
// changeCompType(){
//   this.componentList = this.filtercomponentList;
//   if(this.selectedCompType>0){
//     this.componentList = this.componentList.filter(x=>x.comTypeAuto==this.selectedCompType);

//   }
// }

  FamilyChanged() {
  //  this._dropDownListsFiltered.modelList = this._dropDownLists.modelList.filter(
  //     m => m.MakeId === this.selectedMake.Id
  //   );
    

  //new code
   this._equipmentService.GetModelListByfamilyandMakeLifePerformance(this.selectedMakeValue !=null ? this.selectedMakeValue:0,this.typeid).subscribe(r => {

  
   // this._equipmentService.GetModelListByfamilyandMakeLifePerformance(this.selectedMake.Id,203).subscribe(r => {
      //this.modelList = r;
      this._componentService.availableModelList = r;
      //this._loading.finishedLoading();
    });
  }

  jobsiteChanged(event:any) {
  this.selectedJobsite = event.value;
    this._fleetService.getEquipmentList(this.selectedJobsite).subscribe(result => {
      this.equipmnentList = result
    })
  }

  modelChanged(event) {
    this.selectedModel = event.value;
    if (!this.selectedModel) {
      return;
    }
   // this.inventorySearchFilter.ModelId = this.selectedModel.Id;
    //this.search();
  }
  searchIsVisible(value:boolean)
  {this.show=value}

  // tableVisible(value:boolean)
  // {this.showTable=value}

  checkboxChangedCount(event)
  {
    this.IscountCheckedValues=event.checked
    //console.log(this.IscountCheckedValues)
  }
  
  checkboxChanged(event) {
     this.isCurrentlyFitted= event.checked
     //console.log(this.isCurrentlyFitted)
   }
showloading :boolean=false;
  submitSelection(){
this.showloading=true;
    var status=this;
    this.noRecords = false;
    var params:filterComponentPerformance = {
      //customerID:this.selectedCustomer.Id,
      customerID:this.selectedCustomerValue,
      jobsiteID:this.selectedJobsite,
      brandID:this.selectedMakeValue,
      modelID:this.selectModelValue,
      familyID:this.typeid,
      EquipmentId:this.EquipmentId,
      jobsiteTypeID:this.selectedJobsiteType,
      componentID:this.selectedComp,
      side:this.selectedSide,
      componentTypeID:this.selectedCompType,
      startDate:this.startDate,
      endDate:this.enddate,
      IsCurrentlyFitted: status.isCurrentlyFitted
  
     }

     this._equipmentService.submitSelection(params).subscribe(res=>{
      //Graphdata.dataset=[];
       this.performSearchedList=res;

      this.showloading=false;
      this.FilteredGraphData = this.performSearchedList.GraphData;
        //console.log("result", this.performSearchedList)
        //console.log("graph data", this.FilteredGraphData)
        this.dataSource.data = this.performSearchedList.AvaiblePerformancesList;
       if (this.performSearchedList.AvaiblePerformancesList.length == 0)
         this.noRecords = true;
       else
         this.noRecords = false;
       // console.log(this.performSearchedList.AvaiblePerformancesList[0].Cost)

      //Graph Data
       //console.log('graphfiltered',this.FilteredGraphData);
      //  this.FilteredGraphData.map(x => {
      //     if( Graphdata.data.length>0){
      //       var checkhassamedate  = Graphdata.data.find(y=>y.label==x.endDate);
      //       if(!checkhassamedate){
      //         Graphdata.data.push({"label":  x.endDate, "value" : x.hoursOnSurface.toString() });             

      //       }
      //     }else{
      //       Graphdata.data.push({"label":  x.endDate, "value" : x.hoursOnSurface.toString() });             

      //     }


      this.FilteredGraphData.map(x => {
          
         
            Graphdata.dataset[0].data.push({"label":  x.endDate, "value" : x.hoursOnSurface.toString() });             

          
        


})  


     })


  }
//set Uppr/Lower limit

setGraphLimits(){
var upperValuesselected= Graphdata.trendlines[0].line.find(y=>y.startvalue==this.selectUpperValue);
if(!upperValuesselected){
  
  Graphdata.trendlines[0].line.push({"startvalue" : this.selectUpperValue, "color": '#808080', "alpha": '', "thickness" : ''});
}


var lowerValuesselected= Graphdata.trendlines[0].line.find(y=>y.startvalue==this.selectLowerValue);
if(!lowerValuesselected){
  Graphdata.trendlines[0].line.push({"startvalue" : this.selectLowerValue, "color": '#d78700', "alpha": '', "thickness" : ''});
}

}

// caculate Averages
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }
  averageLife() {
    var total=0;
    var average;
    for(let count=0;count<this.selection.selected.length;count++){
      total += this.selection.selected[count].hoursOnSurface;

     average= total/(count +1)
    }
    
    if (isNaN(average)) {
      return '0';
    }
    else{
      return average.toFixed(1);
    }
  }

  averageNormalized()
  {
    var total=0;
    var averageNormalized;
    for(let count=0;count<this.selection.selected.length;count++){
      total += this.selection.selected[count].normalize100;

     averageNormalized= total/(count +1)
    }
    if (isNaN(averageNormalized)) {
      return '0';
    }
    else{
      return averageNormalized.toFixed(1);
    }
    
  }
  
  averageNormalized120()
  {
    var total=0;
    var averageNormalized120;
    for(let count=0;count<this.selection.selected.length;count++){
      total += this.selection.selected[count].normalize120;

     averageNormalized120= total/(count +1)
    }
    if (isNaN(averageNormalized120)) {
      return '0';
    }
    else{
      return averageNormalized120.toFixed(1);
    }
  }
averageCostperHour()
{
  var total=0;
    var averageCostperHour;
    for(let count=0;count<this.selection.selected.length;count++){
      total += this.selection.selected[count].costPerhour;

      averageCostperHour= total/(count +1)
    }
    if (isNaN(averageCostperHour)) {
      return '0';
    }
    else{
      return averageCostperHour.toFixed(1);
    }
    
}



  
  DownloadCSVFile() { 
    this.downloadFile(this.dataSource.data)
  }
 
  //download csv file
  downloadFile(data: any) {
 
    //console.log("data", data)
 
   
 
    let _data = []
 
    data.map(p => {
      let _o = {}
      for (var key in p) {
        if (p.hasOwnProperty(key)) {
 
          if(key == "EquipmentID"){
            _o["Equipment ID"] = p[key] 
          }else if(key == "customerName"){
            _o["Customer"] = p[key]
          }else if(key == "jobSiteName"){
            _o["Jobsite"] = p[key]
          }else if(key == "brandName"){
            _o["Make"] = p[key]
          }else if(key == "FamilyName"){
            _o["Family"] = p[key]
          }else if(key == "modelName"){
            _o["Model"] = p[key]
          }else if(key == "serialNo"){
            _o["Serial No"] = p[key]
          }else if(key == "unitNo"){
            _o["Unit No"] = p[key]
          }else if(key == "systypeName"){
            _o["System"] = p[key]
          }else if(key == "ComponentType"){
            _o["Component Type"] = p[key]
          }else if(key == "componentName"){
            _o["Component"] = p[key]
          }else if(key == "part"){
            _o["Part"] = p[key]
          }else if(key == "side"){
            _o["Side"] = p[key]
          }else if(key == "hoursOnSurface"){
            _o["Hours On Surface"] = p[key]
          } else if(key == "worn"){
            _o["Last Known Worn %"] = p[key]
          }else if(key == "evalCode"){
            _o["Last Known Evaluation"] = p[key]
          }else if(key == "Cost"){
            _o["Cost"] = p[key]
          }else if(key == "startDate"){
            _o["Start Date"] = p[key]
          }else if(key == "normalize100"){
            _o["Normalize 100%"] = p[key]
          }else if(key == "normalize120"){
            _o["Normalize 120%"] = p[key]
          }else if(key == "endDate"){
            _o["Date Removed"] = p[key]
          }
        }
    }
 
    _data.push(_o)
    })
 
    const replacer = (key, value) => value === null ? '' : value; 
    const header = Object.keys(_data[0]);
    let csv = _data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');
    var a = document.createElement('a');
    var blob = new Blob([csvArray], { type: 'text/csv' }),
      url = window.URL.createObjectURL(blob);
 
    a.href = url;
    a.download = `ComponentLife_Report.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

//Graph Date
loadGraphData()
{
  // this.FilteredGraphData.map


}

changeCheckbox(value: boolean, key, index: number) {
  if (value === false) {
    this.removeArrayelement(this.displayedColumns, key)
  } else {
    this.displayedColumns.splice(index, 0, key)
  }
}
removeArrayelement(arr, key) {
  let a = arguments, L = a.length, ax;
  while (L > 1 && arr.length) {
    key = a[--L];
    while ((ax = arr.indexOf(key)) !== -1) {
      arr.splice(ax, 1);
    }
  }
  return arr;
}

OpenActionHistroy(row:ComponentPerformanceVM){
  //console.log("row", row)
  this._equipmentService.GetComponentActionHistory(row.EquUNit,row.EquipmentID).subscribe(res=>{
    //console.log("result", res)
    this.OpenHistroyPopUp(res);

  })
}

OpenHistroyPopUp(res:ComponentActionHistroyVM[]) {
  const HistoryDialog = this._dialog.open(ComponentActionHistoryComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        componentHistroy: res,
      }
  });

  HistoryDialog.afterClosed().subscribe(newMeterReading => {
     
  });
}


}


